<template>
  <div class="tables-edit-outer">
    <div v-if="!isEditting" class="tables-edit-con">
      <a v-if="isTitle" class="value-con" href="javascript:void(0)" @click="editParams">{{ value }}</a>
      <span v-else class="value-con">{{value}}</span>
      <Button v-if="editable" @click="startEdit" class="tables-edit-btn" style="padding: 2px 4px;" type="text"><Icon type="checkmark"></Icon></Button>
    </div>
    <div v-else class="tables-editting-con">
      <div v-if="isDate" style="display: inline-block">
        <DatePicker type="datetime" placeholder="请选择日期时间" v-model="formItem.time" @on-change="handleInput" style="width: 170px"></DatePicker>
      </div>
      <div v-else-if="isAlbum" style="display: inline-block">
        <Select v-model="formItem.albumId" :label="formItem.album" @on-change="handleInput" style="width: 110px">
          <Option v-for="item in albumList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </div>
      <div v-else style="display: inline-block; width: 72%;">
        <Input :value="value" @input="handleInput" class="tables-edit-input" style="width: 100%"/>
      </div>
      <Button @click="saveEdit" style="padding: 6px 4px;" type="text"><Icon type="checkmark"></Icon></Button>
      <Button @click="canceltEdit" style="padding: 6px 4px;" type="text"><Icon type="close"></Icon></Button>
    </div>
      <Modal v-model="modal" width="920px" :closable="true" :mask-closable="false" :styles="{top: '5%'}">
        <p slot="header" style="font-weight: bold;font-size: 16px; text-align:center">
          <span>文章内容编辑</span>
        </p>
        <Form ref="formItem" :model="formItem" :label-width="80" class="materialForm" :rules="ruleValidate">
          <FormItem prop="title" label="推文标题">
            <Input v-model="formItem.title" placeholder="请输入" clearable style="width: 800px"></Input>
          </FormItem>
          <FormItem label="推文链接">
            <Input v-model="formItem.url" disabled style="width: 800px"></Input>
          </FormItem>
          <FormItem label="作者" prop="author">
            <Input v-model="formItem.author" clearable style="width: 180px"></Input>
          </FormItem>
          <FormItem label="更新时间" prop="time">
            <DatePicker type="datetime" placeholder="选择日期" v-model="formItem.time" style="width: 180px" readonly></DatePicker>
          </FormItem>
          <FormItem label="专辑" prop="album">
            <Select v-model="formItem.albumId" :label="formItem.album" style="width: 180px">
              <Option v-for="item in albumList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="正文" prop="content">
            <Editor v-model="formItem.content" style="width: 800px"></Editor>
            <Button @click="getContent"><a :href="formUrl" target="_blank">点击跳转到原文页面复制推文内容到文本框</a></Button>
          </FormItem>
        </Form>
        <div slot="footer" style="text-align: center">
          <Button size="large" @click="cancelModalEdit">取消</Button>
          <Button type="primary" size="large" :loading="loading2" @click="saveModalEdit">保存</Button>
        </div>
      </Modal>
  </div>
</template>

<script>
import Editor from "./Editor";
export default {
  name: 'TablesEdit',
  components: {Editor},
  props: {
    value: [String, Number, Date],
    edittingCellId: String,
    params: Object,
    editable: Boolean,
    albumList: Array
  },
  data () {
    return {
      formUrl: '',
      modal: false,
      loading2: false,
      formItem: {},
      ruleValidate: {
        title: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        /*author: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],*/
        album: [
          { required: true, message: '请选择专辑', trigger: 'blur' }
        ],
        /*content: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],*/
        /*time: [
          { required: true, type: 'date', message: '请选择日期', trigger: 'change' }
        ]*/
      },
    };
  },
  computed: {
    isEditting () {
      return this.edittingCellId === `editting-${this.params.index}-${this.params.column.key}`;
    },
    isTitle () {
      return this.params.column.key === 'title';
    },
    isDate (){
      return this.params.column.key === 'time';
    },
    isAlbum (){
      return this.params.column.key === 'album';
    }
  },
  methods: {
    editParams (){
      this.modal = true;
    },
    handleInput (val) {
       this.$emit('input', val);
    },
    startEdit () {
      this.$emit('on-start-edit', this.params);
    },
    saveEdit () {
      this.$emit('on-save-edit', this.params);
    },
    canceltEdit () {
      this.$emit('on-cancel-edit', this.params);
    },
    saveModalEdit () {
      this.loading2 = true;
      setTimeout(() => {
        this.loading2 = false;
        this.$refs.formItem.validate((valid) => {
          if (valid) {
              if (this.formItem.content){
                  if (this.formItem.content[1] !== 'p'){
                      this.formItem.content = '<p>' + this.formItem.content + '</p>';
                  }
              }else {
                  this.formItem.content = '<p>该文章内容暂未编辑</p>';
              }
            this.formItem.updateTime = this.formItem.time;
            this.$emit('on-save-modal', this.params);
            this.modal = false;
          } else {
            this.$Message.error('操作失败!');
          }
        });
      }, 1000);
    },

    cancelModalEdit (){
      this.$refs.formItem.resetFields();
      this.modal = false;
    },

    getContent(){
      this.formUrl = this.formItem.url;
    }
  },

  created() {
    this.formItem = this.params.row;
  }
};
</script>

<style lang="less">
  .w-e-menu{
    z-index: 2 !important;
  }
  .w-e-text-container{
    z-index: 1 !important;
  }
.tables-edit-outer{
  height: 100%;
  .tables-edit-con{
    position: relative;
    height: 100%;
    .value-con{
      vertical-align: middle;
    }
    .tables-edit-btn{
      position: absolute;
      right: 10px;
      top: 0;
      display: none;
    }
    &:hover{
      .tables-edit-btn{
        display: inline-block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// edit.vue?0f7ab66c